module.exports = __webpack_public_path__ + "img/azvi.74aed764.png";